import { Text } from "@/components/ui/baseUi/text"
import type { MediaItemFormType } from "@/modules/common/media/mediaFormTypes"
import { cn } from "@/modules/lib/utils"
import { type MediaBlockItemFormikType } from "@/modules/sessions/sessionForm/blocks/mediaBlock/mediaBlockFormikTypes"
import { word } from "@modules/core/utils/i18n"

type MediaExistingBlockImageProps = {
  media: MediaBlockItemFormikType | MediaItemFormType
  className?: string
} & React.ComponentProps<"div">

export function MediaExistingBlockImage({ media, className, ...props }: MediaExistingBlockImageProps) {
  const source = media.file ? URL.createObjectURL(media.file) : media.url

  return (
    <div className={cn("flex flex-row items-center justify-start gap-3 overflow-hidden", className)} {...props}>
      <div style={{ width: 190, height: 90 }} className="flex flex-row justify-center overflow-hidden">
        {media.file || media.url ? (
          <img src={source ?? undefined} alt="media" />
        ) : (
          <Text fontStyle="BM" className="wrap-break-word">
            {word("sessionForm.blocks.add_media.missing_error")}
          </Text>
        )}
      </div>
      <Text fontStyle="BM" className="overflow-hidden overflow-ellipsis">
        {media.filename}
      </Text>
    </div>
  )
}
